import { Locale } from './types';
export var DEFAULT_LOCALE = Locale.Ru;
